import styled from '@emotion/styled';
export const GamingWidgetContentWrapper = styled.div `
  width: 80%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  justify-content: center;
  align-items: center;
`;
export const GamingWidgetContentHeader = styled.div `
  color: #fff;
  font-size: 14px;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
`;
export const GamingWidgetContentText = styled.div `
  color: rgb(125, 140, 180);
  font-size: 12px;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
`;
